/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramNotificationsUserControllerSubscribeToFcmMutationRequest,
  TelegramNotificationsUserControllerSubscribeToFcmMutationResponse,
  TelegramNotificationsUserControllerSubscribeToFcm401,
} from '../../types/TelegramNotificationsUserControllerSubscribeToFcm.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramNotificationsUserSubscribeToFcm } from '../../methods/telegramNotificationsUserSubscribeToFcm.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramNotificationsUserSubscribeToFcmMutationKey = () =>
  [{ url: '/api/user/telegram/notifications/subscribe-fcm' }] as const;

export type TelegramNotificationsUserSubscribeToFcmMutationKey = ReturnType<
  typeof telegramNotificationsUserSubscribeToFcmMutationKey
>;

/**
 * {@link /api/user/telegram/notifications/subscribe-fcm}
 */
export function useTelegramNotificationsUserSubscribeToFcm<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramNotificationsUserControllerSubscribeToFcmMutationResponse,
      ResponseErrorConfig<TelegramNotificationsUserControllerSubscribeToFcm401>,
      { data: TelegramNotificationsUserControllerSubscribeToFcmMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramNotificationsUserControllerSubscribeToFcmMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramNotificationsUserSubscribeToFcmMutationKey();

  return useMutation<
    TelegramNotificationsUserControllerSubscribeToFcmMutationResponse,
    ResponseErrorConfig<TelegramNotificationsUserControllerSubscribeToFcm401>,
    { data: TelegramNotificationsUserControllerSubscribeToFcmMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramNotificationsUserSubscribeToFcm(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
